import type { ManagerAgent } from '../../services/manager.service';

/**
 * Pure helpers for the manager Team roster page. Kept free of React/service
 * concerns so the matching/labelling logic is unit-testable in isolation.
 */

/** Case-insensitive filter of agents by name or email. Empty/blank query
 *  returns the list unchanged. */
export function filterAgents(agents: ManagerAgent[], query: string): ManagerAgent[] {
  const q = query.trim().toLowerCase();
  if (!q) return agents;
  return agents.filter((a) => {
    const full = `${a.first_name} ${a.last_name}`.toLowerCase();
    return full.includes(q) || a.email.toLowerCase().includes(q);
  });
}

/** "12 clients" / "1 client" / "No clients" — book-size label. Treats a
 *  missing client_count (older payloads) as 0. */
export function clientCountLabel(count = 0): string {
  if (count === 0) return 'No clients';
  return `${count} client${count === 1 ? '' : 's'}`;
}
